import React from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';

import {flashMessage} from 'shared/actions/notifications';
import {pathWithoutModal} from 'shared/utils';
import {newCommunityServiceObject} from 'shared/portfolio/actions/community-service';
import {setModalPending} from 'shared/college-profile/actions/college-profile';

import CommunityService from 'shared/components/form-inputs/community-service';
import CommunityServiceFormWrapper, {
  CommunityServiceForm,
} from 'shared/portfolio/components/community-service/community-service-form-wrapper';
import Modal from 'shared/components/modal';
import ModalFooter from 'shared/portfolio/components/modal-footer';

export const CommunityServiceModal = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleClose = () =>
    history.replace({
      pathname: pathWithoutModal('/community-service/new'),
      state: {skipScrolling: true},
    });

  return (
    <Modal show onClose={handleClose}>
      <Modal.TextHeader onClose={handleClose}>Community Service</Modal.TextHeader>
      <CommunityServiceFormWrapper
        initialValues={newCommunityServiceObject() as CommunityServiceForm}
        onSuccess={() => {
          handleClose();
          dispatch(setModalPending('volunteer'));
          dispatch(flashMessage('Saved community service!'));
        }}
      >
        <Modal.Body>
          <CommunityService />
        </Modal.Body>
        <ModalFooter />
      </CommunityServiceFormWrapper>
    </Modal>
  );
};

export default CommunityServiceModal;
